import { Controller } from "@hotwired/stimulus"

export default class NumpadController extends Controller {
  static targets = ["input"]

  connect() {
    window.addEventListener("keyup", this.keyHandler)
  }

  disconnect() {
    window.removeEventListener("keyup", this.keyHandler)
  }

  keyHandler = (event) => {
    // numbers 0–9
    if (/^[0-9]$/.test(event.key)) {
      this.addDigit(event.key)
    }

    // backspace or delete
    if (event.key === "Backspace" || event.key === "Delete") {
      this.backspace()
    }

    // enter
    if (event.key === "Enter") {
      this.submit()
    }
  }

  add(event) {
    const digit = event.currentTarget.dataset.digit
    if (digit) this.addDigit(digit)
  }

  addDigit(digit) {
    if (!this.hasInputTarget) return

    const maxLength = this.inputTarget.max > 0 ? this.inputTarget.max : Number.POSITIVE_INFINITY

    if (this.inputTarget.value.length < maxLength) {
      this.inputTarget.value += digit
      this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    }
  }

  backspace() {
    if (this.hasInputTarget) {
      this.inputTarget.value = this.inputTarget.value.slice(0, -1)
      this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    }
  }

  submit() {
  }
}
